module.exports = __webpack_public_path__ + "static/media/Tollinton Market, or Inside View of the Exhibition Building.98a13648.jpg";